// ProductsData.js
import axios from 'axios';

const PRODUCTS_ENDPOINT = '/products.json';
const PRODUCTS_DATA_KEY = 'products';
const ID_KEY = 'id';
const TITLE_KEY = 'title';
const VENDOR_KEY = 'vendor';
const HANDLE_KEY = 'handle';
const VARIANTS_KEY = 'variants';
const IMAGES_KEY = 'images';
const FEATURED_IMAGE_KEY = 'featured_image';
const SRC_KEY = 'src';
const PRODUCT_TYPE_KEY = 'product_type';
const LIMIT_PER_PAGE = 20; // Products per page as requested

const fetchProductsPage = async (baseUrl, page = 1) => {
    try {
        const url = `${baseUrl}${PRODUCTS_ENDPOINT}?page=${page}&limit=${LIMIT_PER_PAGE}`;
        const response = await axios.get(url);
        const { data } = response;
        if (data && data[PRODUCTS_DATA_KEY] && Array.isArray(data[PRODUCTS_DATA_KEY])) {
            return data[PRODUCTS_DATA_KEY];
        } else {
            return [];
        }
    } catch (error) {
        console.error(`Error fetching product data (page ${page}):`, error);
        return [];
    }
};

const processProductData = (products, baseUrl) => {
    return products.map(product => ({
        id: product[ID_KEY],
        image: product[VARIANTS_KEY][0]?.[FEATURED_IMAGE_KEY]?.[SRC_KEY] || product[IMAGES_KEY][0]?.[SRC_KEY] || '',
        title: product[TITLE_KEY],
        vendor: product[VENDOR_KEY],
        link: `${baseUrl}/products/${product[HANDLE_KEY]}`, // Construct full product link
        collection: product[PRODUCT_TYPE_KEY],
        handle: product[HANDLE_KEY],
    }));
};

// This function fetches only one page of products (LIMIT_PER_PAGE)
const getProductsData = async (baseUrl, page = 1) => {
    const fetchedProducts = await fetchProductsPage(baseUrl, page);
    return processProductData(fetchedProducts, baseUrl);
};

// New function to get the total count of products
const getTotalProductsCount = async (baseUrl) => {
    let totalCount = 0;
    let page = 1;
    let productsOnPage = [];

    try {
        do {
            productsOnPage = await fetchProductsPage(baseUrl, page);
            totalCount += productsOnPage.length;
            page++;
        } while (productsOnPage.length === LIMIT_PER_PAGE); // Continue as long as a full page is returned
    } catch (error) {
        console.error("Error calculating total products count:", error);
        return 0; // Return 0 or handle error as appropriate
    }
    return totalCount;
};

export { getProductsData, LIMIT_PER_PAGE, getTotalProductsCount };